import { useEffect } from "react";
import { App } from "antd";
import { useParams } from "react-router";
import styles from "./style.module.scss";
import { useReindex } from "hooks/useReindex";
import { useUserPermission } from "hooks/useUserPermission";

interface ReindexModalProps {
  open: boolean;
  onClose: () => void;
}

export default function ReindexModal({ open, onClose }: ReindexModalProps) {
  const { datasetId, newDatasetId } = useParams();
  const { modal } = App.useApp();

  const { reindex, isLoading } = useReindex(datasetId || newDatasetId, {
    onSuccess: onClose,
  });

  const canReindex = useUserPermission("can_reindex");

  useEffect(() => {
    if (!open || !canReindex) return;

    const instance = modal.confirm({
      title: "Re-index Dataset",
      width: 520,
      content: (
        <div className={styles.contentWrapper}>
          <span className={styles.title}>
            Your new data isn’t fully indexed, so actions like label propagation
            aren’t available yet.
          </span>
          <span className={styles.subTitle}>
            <b>Tip:</b> If more data is coming, Wait and index it all together.
            You can continue exploring meanwhile.
          </span>
        </div>
      ),
      okText: "Re-Index",
      okButtonProps: {
        loading: isLoading,
        disabled: isLoading,
      },
      closable: true,
      onOk: () => {
        if (!isLoading) {
          reindex();
        }
      },
      onCancel: () => {
        onClose();
      },
      cancelButtonProps: { hidden: true },
    });

    return () => {
      instance.destroy();
    };
  }, [open, canReindex, modal, onClose, isLoading, reindex]);

  return null;
}
